export default __webpack_public_path__ + "static/0019-09c664670cdbc714e75ab66e3d02a96f.png";